import { z } from 'zod';
import { PackageExperienceSchema } from './Experience.schema';
import { PackageRestaurantSchema } from './Tables.schema';

//we save a 'numberOfDays' field returned from the BE when this actually represents what the admin user
//has input as the number of nights for a package
//this transformation irons out this difference
export const PackageSchema = z
  .object({
    experiences: z.array(PackageExperienceSchema),
    rateId: z.string(),
    restaurants: z.array(PackageRestaurantSchema).optional(),
    numberOfDays: z.number(),
    propertyId: z.string(),
    meta: z
      .object({
        entityType: z.literal('SpaPackage').optional(),
        entityId: z.string().optional(),
      })
      .optional(),
  })
  .transform((pkg) => ({
    ...pkg,
    numberOfNights: pkg.numberOfDays,
    numberOfDays: pkg.numberOfDays + 1,
  }));

export type Package = z.infer<typeof PackageSchema>;
